import { Cookies } from 'react-cookie';

import { VulnerabilityCreateFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PostVulOnMapProps {
  vul: VulnerabilityCreateFormValues;
  objectSlug: string;
  floorPlan: string;
}

export const postVulOnMap = async ({ vul, objectSlug, floorPlan }: PostVulOnMapProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const fd = new FormData();

  fd.append('category', vul.category);
  fd.append('criticality', vul.criticality);
  fd.append('discovered', vul.discovered);
  fd.append('responsible', vul.responsible);
  fd.append('comment', vul.comment);
  fd.append('x_coord', vul.x_coord.toString());
  fd.append('y_coord', vul.y_coord.toString());
  fd.append('floor_plan_slug', floorPlan);
  fd.append('create_date', vul.create_date);
  if (Array.isArray(vul.before_photos) && vul.before_photos.length > 0) {
    vul.before_photos.forEach(file => {
      fd.append('before_photos', file);
    });
  }
  const data = await axiosInterceptor.post(`/objects/${objectSlug}/vulnerabilities/?floor_plan_slug=${floorPlan}`, fd, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data as any;
};
